import axios from './Axios'

export const getInterface = (id) => axios.get(`/cardUser/profileView/${id}`);
export const addLocation = (id,liveLocation) => axios.post(`/cardUser/add-location/${id}`,liveLocation)  //add location